// Canonical AAGUID contract — mirrors shared.constants.webauthn on the BE.
export const AAGUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
export const NULL_AAGUID = '00000000-0000-0000-0000-000000000000';

const CATALOG_PATH = '/fido/catalog.json';

export type AaguidCatalog = Readonly<Record<string, string>>;

export async function fetchAaguidCatalog(
  cdnBaseUrl: string
): Promise<AaguidCatalog> {
  const response = await fetch(`${cdnBaseUrl}${CATALOG_PATH}`);

  if (!response.ok) {
    throw new Error(
      `Failed to fetch AAGUID catalog: ${response.status} ${response.statusText}`
    );
  }

  const raw: unknown = await response.json();

  if (raw === null || typeof raw !== 'object' || Array.isArray(raw)) {
    throw new Error('AAGUID catalog is not a JSON object');
  }

  const catalog: Record<string, string> = {};

  for (const [aaguid, name] of Object.entries(raw)) {
    // The null AAGUID means "model unidentified" — offering it would let an
    // admin allowlist every authenticator that declines to identify itself.
    if (aaguid === NULL_AAGUID) {
      continue;
    }

    if (!AAGUID_PATTERN.test(aaguid)) {
      continue;
    }

    if (typeof name !== 'string' || !name) {
      continue;
    }

    catalog[aaguid] = name;
  }

  return catalog;
}
